import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "courseIdInput", "messageInput"]

  open(event) {
    this.courseIdInputTarget.value = event.currentTarget.dataset.courseId
    this.messageInputTarget.value = ""
    this.modalTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
    this.messageInputTarget.focus()
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }

  closeOnBackdrop(event) {
    if (event.target === event.currentTarget) this.close()
  }
}
